import { defineComponent as _defineComponent } from 'vue'
import { useWiFiModel } from './../model'

export default /*#__PURE__*/_defineComponent({
  __name: 'WiFiButton',
  setup(__props) {

const wifiModel = useWiFiModel()

return { __sfc: true,wifiModel }
}

})